"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionClient = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const BaseClient_1 = require("../BaseClient");
class FunctionClient extends BaseClient_1.BaseClient {
    constructor(baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
    }
    async executeFunction(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/function',
            data: request,
        });
        return response.data;
    }
}
exports.FunctionClient = FunctionClient;
